import { Maybe } from "../option";
export class ForgetfulStack {
    constructor(depth) {
        this.depth = depth;
        this._inner = [];
    }
    current() {
        const last_idx = this._inner.length - 1;
        const value = this._inner.length > 0 ? this._inner[last_idx] : null;
        return Maybe(value);
    }
    push(val) {
        const last_idx = this._inner.length - 1;
        if (val === this._inner[last_idx])
            return this._inner.length;
        this._inner.push(val);
        const current_len = this._inner.length;
        this._inner = this._inner.slice(current_len - this.depth - 1);
        return this._inner.length;
    }
    pop() {
        return Maybe(this._inner.pop());
    }
    repr(fn) {
        return this._inner.map(fn);
    }
}
